import { render, staticRenderFns } from "./CustomTableHeader.vue?vue&type=template&id=37ea0c41&scoped=true"
import script from "./CustomTableHeader.vue?vue&type=script&lang=js"
export * from "./CustomTableHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomTableHeader.vue?vue&type=style&index=0&id=37ea0c41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea0c41",
  null
  
)

export default component.exports